import Component from './component';
import { makeDefault } from './defaults';
import { isValidData } from './validator';

export const Sticky = {
  Component,
  makeDefault,
  isValidData,
} as const;

export type { StickyData, StickyNodeData } from './types';
